import React from "react";

export const money = (n: number | null | undefined) =>
  n == null ? "—" : `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const pct = (n: number | null | undefined) => (n == null ? "—" : `${Number(n).toFixed(1)}%`);

export function PageTitle({ title, subtitle, right }: { title: string; subtitle?: string; right?: React.ReactNode }) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function Stat({ label, value, tone = "slate", testid }: { label: string; value: React.ReactNode; tone?: string; testid?: string }) {
  const tones: Record<string, string> = {
    slate: "text-slate-900", emerald: "text-emerald-600", blue: "text-blue-600",
    amber: "text-amber-600", red: "text-red-600", indigo: "text-indigo-600",
  };
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm" data-testid={testid}>
      <p className="text-xs font-medium text-slate-500">{label}</p>
      <p className={`mt-1 font-display text-2xl font-semibold ${tones[tone] || tones.slate}`}>{value}</p>
    </div>
  );
}

export function Badge({ status }: { status?: string }) {
  const map: Record<string, string> = {
    quota_met: "bg-emerald-100 text-emerald-700", below_quota: "bg-slate-100 text-slate-600",
    target_met: "bg-emerald-100 text-emerald-700", near_target: "bg-amber-100 text-amber-700",
    below_target: "bg-red-100 text-red-700",
    earned: "bg-emerald-100 text-emerald-700", paid: "bg-blue-100 text-blue-700",
    held: "bg-amber-100 text-amber-700", reversed: "bg-red-100 text-red-700",
    pending: "bg-slate-100 text-slate-600", adjusted: "bg-indigo-100 text-indigo-700",
    unpaid: "bg-slate-100 text-slate-600", draft: "bg-slate-100 text-slate-600",
    approved: "bg-indigo-100 text-indigo-700", processing: "bg-amber-100 text-amber-700",
    failed: "bg-red-100 text-red-700", none: "bg-slate-100 text-slate-500",
    full: "bg-red-100 text-red-700", partial: "bg-amber-100 text-amber-700",
  };
  const s = status || "—";
  return <span className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium ${map[s] || "bg-slate-100 text-slate-600"}`}>{s.replace(/_/g, " ")}</span>;
}

export function Card({ title, children, right }: { title: string; children: React.ReactNode; right?: React.ReactNode }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white shadow-sm">
      <div className="flex items-center justify-between border-b border-slate-100 px-5 py-3">
        <h2 className="text-sm font-semibold text-slate-800">{title}</h2>
        {right}
      </div>
      <div className="p-5">{children}</div>
    </div>
  );
}
